// action type strings
import * as actionTypes from '../../actionTypes';

export function updateImpersonateUser({impersonateUser}) {
  return {
    type: actionTypes.UPDATE_IMPERSONATE_USER,
    impersonateUser
  };
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/sync/impersonation.js